<template>
    <el-dialog  title="处理反馈意见" :visible.sync="showBlock" :destroy-on-close="true" width="600px" :before-close="handleClose">
        <div class="warp-form">
			
			
            <el-form :model="formData" ref="formData" label-width="80px" class="demo-ruleForm">			
	         	<div class="deail">
	         	  <div class="common-items-center" v-for="(item,index) in message" :key="index">
	         	    <span style="margin: 10px;">{{ item.unit }}</span>
	         	    <span>{{ datas[item.key] }}</span>
	         	  </div>
				  <div>
					 <el-form-item label="反馈图片" prop="title">
						    <el-image
                   v-if="datas.resouce"
						       style="width: 100px; height: 100px"
						       :src="datas.resouce"
						       :fit="fit"></el-image>
                <div v-else style="width: 100px; height: 100px;background:#ccc;border-radius:10px;">

                </div>
					 </el-form-item>
				  </div>
	         	</div>			
                <el-form-item  label="处理结果" prop="processResult" :rules="[{required:true,message:'内容描述不能为空'}]">
                    <el-input type="textarea"  maxlength="500" v-model="formData.processResult"  placeholder="请输入内容" show-word-limit :autosize="{minRows:3}"  autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item
                        <div  class="dialog-footer">
                            <el-button @click="handleClose">取消</el-button>
                            <el-button type="primary" @click="submitForm('formData')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  export default{

     data(){
       return{
		    fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
            showBlock: false,
			datas:{},
			formData: {
				processResult: null       
			},
			showBlock:false,
			message:[
			  {
			    key:'publishPlatform',
			    unit:'反馈平台:',
			  },
			  {
			    key:'createTime',
			    unit:'接收时间:',
			  },
			  {
			    key:'publishUser',
			    unit:'反馈人员:',
			  },
			  {
			    key:'phone',
			    unit:'联系方式:',
			  }, 
			  {
			    key:'content',
			    unit:'反馈内容:',
			  }
			]
       }
     }, 
     created(){
       
     },
     methods:{

        //重置输入框信息
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.dealMess()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //新增BTn
        async dealMess(){
            let parms = {
                processResult:this.formData.processResult, 
                processStatus:1
            }
			console.log(parms)
            let urlHttp = operate.UPDATESUGGEST 
				//编辑
                parms.id = this.formData.id         	
				console.log(parms)
				console.log(urlHttp)
                await postFun(urlHttp,parms,res=>{
                  if(res.code==1){
                     this.$parent.resetBtn()
                     this.showBlock = false
                     this.handleClose()
                  }
                })
                     
        },

        //开启弹窗
        showMessage(ev,val){		
        val = JSON.parse(JSON.stringify(val))
			this.formData=val
			this.datas=val		
			switch(val.publishPlatform*1){
				case 1:
				this.datas.publishPlatform="运营"
				
				break
				case 2:
				this.datas.publishPlatform="工厂"
				break
				case 3:
				this.datas.publishPlatform="代理商"
				break
				case 4:
				this.datas.publishPlatform="工程商"
				break
				default:
				break
			}
			console.log(this.datas.publishPlatform)
			console.log(this.datas)
            this.showBlock = true                                
        },
       
        //关闭弹窗
        handleClose() {
            this.showBlock = false
           
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   .warp-form{
      ::v-deep .el-input__count{
         background-color: rgba(0, 0, 0, 0);
      }
   }
   
</style>